import { Stack, Box, Typography, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRoutes } from '../ApplicationRoutes';
import { useAuth } from '../Contexts/AuthContext';
import { ErrorDialog } from '../Helpers/ErrorDialog';
import { Header } from '../Layouts/Header';

const LoginPage = () => {
	const navigate = useNavigate();
	const { login } = useAuth();
	const { state } = useLocation();
	const [rememberUser, setRememberUser] = useState(false);
	const [emailInput, setEmailInput] = useState('');
	const [passwordInput, setPasswordInput] = useState('');
	const [error, setError] = useState<string | null>(null);

	const forgotPassword = () => {
		navigate(AppRoutes.ForgotPassword);
	};

	const callLogin = async () => {
		const loginResult = await login(emailInput, passwordInput);
		if (!loginResult) {
			navigate(state?.path ?? AppRoutes.Dashboard);
		} else {
			setError(loginResult);
		}
	};

	// const signup = () => {
	// 	navigate(AppRoutes.Signup);
	// };

	return (
		<Stack
			direction="column"
			width="100%"
			height="100vh"
			justifyContent="center"
			alignItems="center"
			spacing="20px"
		>
			<Header />
			<Typography fontSize="35px" fontWeight={600}>
				ZoneVid
			</Typography>
			<Box
				width="400px"
				style={{
					border: '2px solid rgba(0,0,0,0.1)',
					borderRadius: '20px',
					padding: '30px 30px 20px 30px',
				}}
			>
				<Stack
					direction="column"
					width="100%"
					height="100%"
					justifyContent="start"
					alignItems="center"
				>
					<Typography fontSize="22px" fontWeight={600}>
						Sign In
					</Typography>
					<Typography color="grey">Welcome back! Please enter your details</Typography>
					<TextField
						style={{
							marginTop: '30px',
							width: '100%',
						}}
						label="Email"
						value={emailInput}
						onChange={e => setEmailInput(e.target.value)}
					/>
					<TextField
						style={{
							marginTop: '10px',
							width: '100%',
						}}
						label="Password"
						type="password"
						value={passwordInput}
						onChange={e => setPasswordInput(e.target.value)}
					/>
					<Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
						<Stack direction="row" justifyContent="start" spacing="5px" alignItems="center">
							<input
								type="checkbox"
								checked={rememberUser}
								onChange={() => setRememberUser(!rememberUser)}
							/>
							<Typography>Remember me</Typography>
						</Stack>
						<Button
							style={{
								textTransform: 'none',
							}}
							onClick={forgotPassword}
						>
							Forgot Password?
						</Button>
					</Stack>
					<Button
						variant="contained"
						onClick={() => callLogin()}
						style={{
							width: '100%',
							height: '40px',
							marginTop: '20px',
							textTransform: 'none',
						}}
					>
						Login
					</Button>
					{/* Commenting out to remove signup button per Alex's request */}
					{/* <Stack direction="row" alignItems="center" justifyContent="center" paddingTop="15px">
						<Typography>Don't have an account?</Typography>
						<Button
							onClick={signup}
							style={{
								textTransform: 'none',
							}}
						>
							<Typography>Sign up</Typography>
						</Button>
					</Stack> */}
				</Stack>
			</Box>
			<ErrorDialog title="Login Failed" error={error} onClose={() => setError(null)} />
		</Stack>
	);
};

export default LoginPage;
